import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	Checkbox,
	CheckboxGroup,
	RadioButton,
	RadioButtonGroup,
} from '@aoworld-aotech/components-react';

import {
	facetSelected,
	facetToggled,
	getLister,
	updateDismissFiltersUrl,
	updateFacetNameToScrollTo,
} from '../../../actions/lister-actions';
import {
	useIsBelowSmallOnly,
	useIsSmallAndAbove,
} from '../../../hooks/mediaQueries';
import { scrollToTopOfLister } from '../../../utilities/lister-utilities';
import ColourSwatch from './ColourSwatch';
import TRANSLATIONS from './translations@default.json';

export const FacetValue = ({
	Name: facetTypeHeader,
	IsMultiSelect,
	FacetValues,
	ResetUrl,
	position,
	facetsToShow,
	isColourSwatch,
}) => {
	const dispatch = useDispatch();

	const { dismissFiltersUrl, pageTitle } = useSelector((state) => state);

	const isSelected = FacetValues.some(({ Selected }) => Selected);
	const isSmallAndAbove = useIsSmallAndAbove();
	const isBelowSmallOnly = useIsBelowSmallOnly();

	const handleChange = (evt, facetValue, facetValuePosition) => {
		evt.preventDefault();
		evt.stopPropagation();

		dispatch(facetToggled(facetValue, isSmallAndAbove));

		dispatch(updateFacetNameToScrollTo(facetValue.Name));

		scrollToTopOfLister(isSmallAndAbove);

		const facetData = {
			facetTypeHeader: facetValue.Name,
			facetTypePosition: position,
			facetValue: facetValue,
			facetValuePosition: facetValuePosition,
			pageUrl: dismissFiltersUrl,
			pageTitle: pageTitle,
			storeSelectedFacets: isBelowSmallOnly,
		};

		dispatch(facetSelected(facetData));

		if (isSmallAndAbove) {
			dispatch(updateDismissFiltersUrl(facetValue.Url));
		}
	};

	const resetRadioButton = () => {
		const selectedRadioButton = FacetValues.filter(
			(facet) => facet.Selected
		)[0];

		const facetData = {
			facetTypeHeader: facetTypeHeader,
			facetTypePosition: position,
			facetValue: selectedRadioButton,
			facetValuePosition: 0,
			pageUrl: dismissFiltersUrl,
			pageTitle: pageTitle,
		};

		dispatch(facetSelected(facetData));
		dispatch(
			getLister(ResetUrl, {
				type: '',
				trackHistory: true,
			})
		);
	};

	return IsMultiSelect ? (
		<CheckboxGroup
			name={facetTypeHeader}
			label="Filter based on product feature"
			hideLabel
			fullWidth
			flush>
			{FacetValues.map((facetValue, index) => {
				const { Name, Total, Selected } = facetValue;

				if (index >= facetsToShow) {
					return null;
				}

				if (isColourSwatch) {
					return (
						<ColourSwatch
							key={Name}
							facetPosition={position}
							{...{
								facetValue,
								index,
								handleChange,
							}}
						/>
					);
				}

				return (
					<Checkbox
						data-testid="checkbox"
						key={Name}
						value={Name}
						checked={Selected}
						data-tag-valueName={Name}
						data-tag-sidebarInteractionType="facetInteraction"
						data-tag-exposedFacet=""
						data-tag-facetPosition={`${position + 1}_${index + 1}`}
						data-tag-pageTitle={document.title}
						data-tag-pagePath={window.location.pathname}
						inheritTextStyle
						className="px-4 py-2 md:py-1 hover:bg-lightblue"
						onChange={(evt) => handleChange(evt, facetValue, index)}>
						<div className="flex justify-between">
							<div>{Name}</div>
							{Total && <div>{`(${Total})`}</div>}
						</div>
					</Checkbox>
				);
			})}
		</CheckboxGroup>
	) : (
		<RadioButtonGroup
			name={facetTypeHeader}
			label="Filter based on product feature"
			hideLabel
			fullWidth
			flush>
			<RadioButton
				data-testid="radiobutton"
				value="reset"
				checked={!isSelected}
				inheritTextStyle
				className="px-4 py-3 md:py-1 hover:bg-lightblue"
				onChange={(evt) => resetRadioButton(evt)}>
				<div className="flex justify-between">
					<div>{TRANSLATIONS.All}</div>
				</div>
			</RadioButton>

			{FacetValues.map((facetValue, index) => {
				const { Name, Total, Selected } = facetValue;

				if (index >= facetsToShow) {
					return null;
				}

				return (
					<RadioButton
						data-testid="radiobutton"
						key={Name}
						value={Name}
						checked={Selected}
						data-tag-name={facetTypeHeader}
						data-tag-valueName={Name}
						data-tag-sidebarInteractionType="facetInteraction"
						data-tag-exposedFacet=""
						data-tag-facetPosition={`${position + 1}_${index + 1}`}
						data-tag-pageTitle={document.title}
						data-tag-pagePath={window.location.pathname}
						inheritTextStyle
						className="px-4 py-2 md:py-1 hover:bg-lightblue"
						onChange={(evt) => handleChange(evt, facetValue, index)}>
						<div className="flex justify-between">
							<div>{Name}</div> <div>({Total})</div>
						</div>
					</RadioButton>
				);
			})}
		</RadioButtonGroup>
	);
};
